__turbopack_context__.v({
  "appsColumn": "TemplatesTable-module__VIpxqG__appsColumn",
  "ownerAvatarCentered": "TemplatesTable-module__VIpxqG__ownerAvatarCentered",
  "ownerColumnHeaderCentered": "TemplatesTable-module__VIpxqG__ownerColumnHeaderCentered",
});
